import './index.css'

const AppointmentItem = props => {
  const {eachAppointment, isStarredClick} = props
  const {title, date, id, isStarred} = eachAppointment
  const onStarButton = () => {
    isStarredClick(id)
  }

  const starredImg = isStarred
    ? 'https://assets.ccbp.in/frontend/react-js/appointments-app/filled-star-img.png'
    : 'https://assets.ccbp.in/frontend/react-js/appointments-app/star-img.png'

  return (
    <li className="list-container">
      <div className="item-container">
        <h1 className="item-title">{title}</h1>
        <button type="button" onClick={onStarButton} className="star-button">
          <img src={starredImg} alt="star" />
        </button>
      </div>
      <span className="date-para">Date: {date}</span>
    </li>
  )
}

export default AppointmentItem
